import drivers from './drivers';
import upload from './upload';
import firmware from './firmware';
export default { drivers, upload, firmware };
